import { useState } from "react";

import ListPage from "../../layouts/ListPage";
import PosterContainer from "../../components/Poster/PosterContainer";
import { languages } from "../../utils/translate";

function Posters() {
  const [language, setLanguage] = useState(languages[0]);

  return (
    <ListPage
      title="Posters"
      description=""
      breadcrumbsLinks={[
        {
          url: "/",
          content: "Content Library",
        },
      ]}
      language={language}
      setLanguage={setLanguage}
    >
      <PosterContainer language={language} />
    </ListPage>
  );
}

export default Posters;